import { Card, CardContent, CardHeader } from "@mui/material";
import type { PropsWithChildren } from "react";
import ViewAllWidgetButton from "../ViewAllWidgetButton";

interface Props {
  name: string;
  viewAllTo?: string;
  onViewAllClick?: () => void;
  viewAllDisabled?: boolean;
}

const WidgetPreviewCard = ({
  name,
  viewAllTo,
  onViewAllClick,
  viewAllDisabled,
  children,
}: PropsWithChildren<Props>) => (
  <Card variant="outlined">
    <CardHeader
      title={name}
      action={<ViewAllWidgetButton to={viewAllTo} onClick={onViewAllClick} disabled={viewAllDisabled} />}
      sx={{ p: 1.5 }}
    />
    <CardContent sx={{ pt: 0, pb: 1.5, px: 1.5 }}>{children}</CardContent>
  </Card>
);

export default WidgetPreviewCard;
